<template>
  <v-container class="relatorios-fiscais">
    <v-card class="py-4 px-2 auth-content" tile>
      <v-form v-model="valid" ref="form">
        <PageTitle main="Administração" icon="mdi-pencil-box-outline" sub="Relatórios de gestão fiscal"
          home="/administracao" />
        <input id="user-id" type="hidden" v-model="rgf.usuario" />
        <input id="rgf-id" type="hidden" v-model="rgf.id" />
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field v-model="codigo" label="Código" dense outlined>
              <v-icon slot="append" color="success" large @click="loadDialog">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" v-if="codigo">
            <v-checkbox v-model="rgf.inativar" label="Inativar rgf?" color="success"
              v-show="mode === 'save'"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2" lg="3">
            <v-autocomplete v-model="rgf.tipo" :items="tiposrgf" required dense outlined
              label="Tipo Rgf"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" lg="3">
            <v-autocomplete v-model="rgf.periodo" :items="periodos" required dense outlined
              label="Período"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="8" lg="4">
            <v-text-field v-model="rgf.descricao_tipo" label="Descrição do tipo" required dense outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" lg="6">
            <v-text-field v-model="rgf.descricao_tipo_anexo" label="Descrição do anexo" required dense outlined></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="6">
            <v-text-field v-model="rgf.descricao_periodo" label="Descrição do período" required dense outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-mask="dtp" v-model="data_pub" label="Data de publicação.:" dense outlined
                  @blur="mudaData">
                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker locale="pt-br" v-model="date" @input="dateB">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-text-field v-model="rgf.ano_publicacao" label="Ano da publicação" required dense outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-text-field v-model="rgf.ano" label="Ano de referência" required dense outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-checkbox v-model="rgf.publicado" label="Publicar relatório?" color="success"
              v-show="mode === 'save'"></v-checkbox>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs background-color="primary" dark v-model="tabs">
            <v-tab>
              <v-icon class="mr-1">
                mdi-cog-sync
              </v-icon>
              Carga
            </v-tab>
            <v-tab @click="loadAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    Cargar dados da API Prodata
                    <v-card>
                      <v-container>
                        <v-form>
                          <v-row>
                            <v-col cols="12" md="6" lg="2">
                              <v-text-field v-model="sync.ano" label="Ano de referência" required dense outlined>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-col cols="12" md="2" lg="3">
                            <v-autocomplete v-model="sync.tiposinc" :items="tiposrgf" required dense outlined
                              label="Tipo Rgf"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="2" lg="3">
                            <v-autocomplete v-model="sync.periodosync" :items="periodos" required dense outlined
                              label="Período"></v-autocomplete>
                          </v-col>
                          <v-row class="mt-1">
                            <v-col cols="12" md="6">
                              <v-btn color="success" class="ml-1 mr-4" @click="syncDados">
                                <v-icon left>
                                  mdi-table-sync
                                </v-icon>
                                Carregar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-data-table :headers="headersAnexos" :items="anexos" :search="search">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadAnexo(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadAnexo(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-1 mb-3" v-if="codigo" @click="AddAnexo">
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col cols="12" md="6">
            <v-btn :disabled="!valid" color="success" class="ml-1 mr-4" v-if="mode === 'save'" @click="save">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn color="error" class="mr-4" v-if="mode === 'remove'" @click="remove">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn color="secondary" class="mr-4" @click="reset">
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="dialog" transition="dialog-bottom-transition" fullscreen>
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar color="primary" dark>
                  Pesquisar rgfs
                </v-toolbar>
                <v-card-title>
                  <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
                    hide-details>
                  </v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="rgfs" :search="search">
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon medium color="primary" class="mr-2" @click="loadRgf(item)">
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon medium color="error" class="mr-2" @click="loadRgf(item, 'remove')">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn color="error" @click="dialog.value = false">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog v-model="DialogAnexo" transition="dialog-top-transition">
          <v-card class="py-4 px-2 auth-content" tile>
            <div class="logo-foto ml-4 mt-5">
              <v-form v-model="valid" ref="form" class="altura">
                <PageTitle icon="mdi-pencil-box-outline" sub="Adicionar anexo" />
                <input id="user-id" type="hidden" v-model="anexo.usuario" />
                <input id="anexo-id" type="hidden" v-model="anexo.id" />
                <v-row>
                  <v-col cols="12" md="7" lg="8">
                    <v-text-field v-model="anexo.nome" type="text" label="Nome do arquivo" outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" lg="4">
                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-mask="datp" v-model="date_pub" label="Data de publicacao.:" dense outlined
                          @blur="mudaDataA">
                          <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker locale="pt-br" v-model="date1" @input="dateA">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <input accept="application/vnd.ms-excel, application/pdf" prepend-icon="mdi-camera" label="Anexo"
                    v-if="uploadReady" type="file" ref="file" @change="selectFile()">
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn color="success" class="mr-4" v-if="codigo" type="submit" @click.prevent="fileUpload()">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn color="error" class="mr-4" v-if="codigo" @click="clearUpload">
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn color="danger" class="mr-4" @click="FecharDialog">
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
// import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'RelatoriosFiscais',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    dtp: '##/##/####',
    datp: '##/##/####',
    tabs: null,
    codigo: '',
    dialog: false,
    DialogAnexo: false,
    loading: false,
    uploadReady: true,
    file: '',
    tabela: 'lrfanexos',
    pasta: 'RGF',
    search: null,
    select: null,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_pub: '',
    date_pub: '',
    menu: false,
    menu1: false,
    mode: 'save',
    rgf: {},
    sync: {},
    anexo: {},
    anexos: [],
    rgfs: [],
    tiposrgf: [],
    periodos: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'descricao_tipo' },
      { text: 'Período', value: 'descricao_periodo' },
      { text: 'Ano de referência', value: 'ano' },
      { text: 'Publicação', value: 'dt_publicacao' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Tabela', value: 'tabela' },
      { text: 'pasta', value: 'pasta' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Link', value: 'url' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    dateB () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.date_pub = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataA () {
      const [dia, mes, ano] = this.date_pub.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.rgf.dt_publicacao = this.date
      //  this.rgf.data_termino = this.date1
      const method = this.rgf.id ? 'put' : 'post'
      const id = this.rgf.id ? `/${this.rgf.id}` : ''
      axios[method](`${baseApiUrl}/relatorios-rgf${id}`, this.rgf)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    syncDados () {
      this.sync.periodo = this.rgf.periodo
      this.sync.tipo = this.rgf.tipo
      this.sync.descricao_tipo = this.rgf.descricao_tipo
      this.sync.descricao_periodo = this.rgf.descricao_periodo
      const method = 'post'
      axios[method](`${baseApiUrl}/carga-prodata-lrf-sync`, this.sync)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_rgf', this.rgf.id)
      formData.append('data_publicacao', this.date1)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('subpasta', this.rgf.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.anexo = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    saveAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadAnexos()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadAnexos () {
      const id = this.rgf.id
      const url = `${baseApiUrl}/anexos-do-rgf/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadRgfs () {
      const url = `${baseApiUrl}/relatorios-rgf-filtro`
      axios.get(url).then(res => {
        this.rgfs = res.data.map(item => {
          return {
            ...item,
            dt_publicacao: moment(item.dt_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadTipos () {
      const url = `${baseApiUrl}/tipos-lrf-filter`
      axios.get(url).then(res => {
        this.tiposrgf = res.data.map(item => {
          return {
            ...item,
            value: item.codigo,
            text: `${item.codigo} -- ${item.descricao}`
          }
        })
      })
    },
    loadPeriodos () {
      const url = `${baseApiUrl}/periodos-filter`
      axios.get(url).then(res => {
        this.periodos = res.data.map(item => {
          return {
            ...item,
            value: item.periodo,
            text: ` ${item.periodo} -- ${item.descricao}`
          }
        })
      })
    },
    loadRgf (rgf, mode = 'save') {
      this.mode = mode
      this.rgf = { ...rgf }
      // this.data_pub = moment(rgf.dt_publicacao).format('DD/MM/YYYY')
      this.data_pub = rgf.dt_publicacao
      this.codigo = this.rgf.id
      this.dialog = false
      this.valid = true
      this.loadDatas()
    },
    loadAnexo (anexo, mode = 'save') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.DialogAnexo = true
    },
    AddAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uid_rgf = this.rgf.id
      this.DialogAnexo = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.rgf = {}
    },
    limpar () {
      this.mode = 'save'
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_rgf = this.rgf.id
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.limpar()
    },
    adicionarAnexo () {
      this.saveAnexo()
    },
    adicionarAnexoSair () {
      this.saveAnexo()
      this.DialogAnexo = false
    },
    loadDialog () {
      this.dialog = true
      this.loadRgfs()
    },
    loadDatas () {
      this.mudaData()
      this.mudaDataA()
    },
    loadUser () {
      this.rgf.usuario = this.user.id
      // this.rgf.uuid = uuid.v1()
      this.loadPeriodos()
      this.loadTipos()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}

.text-v-card {
  font-size: 1rem !important;
}

.codigo {
  max-width: 100% !important;
}

.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}

.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}

.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}

ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}

ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}

ul.filtro li a:hover {
  color: #ffffff !important;
}

.container {
  width: 98% !important;
}

.logo-foto {
  max-width: 750px;
}
</style>
